export default "__VITE_ASSET__Sy$mFv4A__";